export enum TicketType {
  Other = 0,
  Turn = 1,
  Punch = 2,
  Inspection = 3,
  Resident = 4,
  Cost = 5,
}
